export default "__VITE_ASSET__BxhqWVpw__"